<template>
	<main class="">
		<blogs type="single"></blogs>
	</main>
</template>

<script>
// Import components
import blogs from '/views/blogs'

export default {
	name: 'blogs-page',
	components: {
		blogs
	}
}
</script>
